<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
	import OrderSection from "../OrderSection.svelte";
	import DetailSection from "./DetailSection.svelte";
	import BlueButton from "../BlueButton.svelte";
	import { MasterService } from "../../services/master.service";
	import Pagination from "../../molecules/Pagination.svelte";

	const name = 'workStyle'
	const label = '勤務形態'
	const service = new MasterService(name)
	let loading = service.store.loading
	let model = service.store.model
	let models = service.store.models
	let currentModels = service.store.currentModels
	let page = service.store.page
	let size = service.store.size

	onMount(async () => {
		await service.getList()
	})
</script>

<div class="flex">
  <SectionBoard>
  	<h2 class="font-semibold">
			{label}
  	</h2>

  	<BlueButton click={service.add} klass="mt-4" rounded>
  		追加
  	</BlueButton>

 		{#if $models.length !== 0}
 			<OrderSection
 				models={$currentModels}
 				handleDndConsider={service.handleDndConsider}
 				handleDndFinalize={service.handleDndFinalize}
 				handleModel={service.handleModel}
 				selected={$model}
 			/>

			<Pagination
				page={$page}
				result={$models.length}
				next={service.handleNext}
				previous={service.handlePrevious}
				klass="mt-4"
			/>
		{/if}
  </SectionBoard>

  {#if $model.id}
    <SectionBoard klass="ml-6">
    	<DetailSection
    		model={$model}
    	  handleLabel={service.handleLabel}
    	  handleOrder={service.handleOrder}
    	  handleDisabled={service.handleDisabled}
    	  save={service.save}
    	  remove={service.remove}
    	  loading={$loading}
				max={$size}
    	/>
    </SectionBoard>
  {/if}
</div>